export const telemetrySdkClientRTTI = Symbol.for("TelemetrySdkClient");
export const telemetrySdkErrorEventGroupRTTI = Symbol.for("TelemetrySdkErrorEventGroup");
